// extracted by mini-css-extract-plugin
export var colorLight = "linkButton-module--color-light--2Pggm";
export var colorLightgray = "linkButton-module--color-lightgray--1lEg6";
export var colorDark = "linkButton-module--color-dark--28cs9";
export var colorBlack = "linkButton-module--color-black---CxM8";
export var colorHacker = "linkButton-module--color-hacker--3vId-";
export var colorCobalt = "linkButton-module--color-cobalt--OPa-2";
export var colorSepia = "linkButton-module--color-sepia--hnq6Y";
export var colorLowcontrast = "linkButton-module--color-lowcontrast--3Es6W";
export var container = "linkButton-module--container--17B-V";